<template>
  <div id="component-container">
    <div id="redirect">
      <b-spinner variant="primary" type="grow" style="width: 5rem; height: 5rem; position: absolute"></b-spinner>
      <br>
      <h2> {{$t('redirect')}}</h2>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Redirect',
    created () {
      // this.$router.go('http://ws-test.clarin-pl.eu/comcorp')
      window.location = 'http://ws.clarin-pl.eu/compcorp'
    }
  }

</script>

<style scoped>
  #redirect {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  #redirect h2 {
    /*position: absolute;               !* 2 *!*/
    /*top: 50%;                         !* 3 *!*/
    /*transform: translate(0, -50%)*/
    margin: 0;
  }   /* 4 */
</style>



// WEBPACK FOOTER //
// src/components/Redirect.vue